import { IRemedyCategory } from '@lifk/types'

export const defaultRemedyCategory: IRemedyCategory = {
  id: 'default-remedy-category',
  name: { 'en-us': 'Custom', 'es-mx': 'Costumbre' },
  categoryColor: '#fab411',
  categoryTextColor: '#fff',
  sortOrder: 100,
  footprintStyles: {
    light: {
      color: '#fbc341',
      lineColor: '#fab411',
      draggingOpacity: 0.4,
      placedOpacity: 0.7,
      selectedOpacity: 0.85
    },
    satellite: {
      color: '#9b6d03',
      lineColor: '#fbc341',
      draggingOpacity: 0.4,
      placedOpacity: 0.7,
      selectedOpacity: 0.91
    }
  }
}
